export default {
  engagementWorkingHours(state) {
    return state.engagementWorkingHours;
  },
};
